/**
 * Eine Gruppe in der Kontext-Sidebar — Überschrift plus ihre Einträge.
 *
 * Die Überschrift ist bewusst klein und ruhig (`text-label`, `--color-muted`,
 * Versalien): Sie ordnet, sie konkurriert nicht mit den Einträgen darunter.
 * Ein Bereich kann mehrere Gruppen tragen — *Ansichten* und später *Nach
 * Objekt* —, und erst dann trägt die Überschrift wirklich etwas bei. Bei einer
 * einzelnen Gruppe ist sie trotzdem da, damit die Sidebar nicht bei jedem
 * Bereich anders aussieht.
 */

import type { ReactNode } from 'react'

interface SidebarSectionProps {
  /** Kurz und in der Sprache der Oberfläche: „Ansichten", nicht „Filter". */
  readonly title: string
  readonly children: ReactNode
}

export function SidebarSection({ title, children }: SidebarSectionProps) {
  return (
    <section className="pt-3">
      <h3 className="text-label text-muted px-(--sidebar-x) pb-1 font-medium tracking-wide uppercase">{title}</h3>
      <ul>{children}</ul>
    </section>
  )
}
